import profileImage from '../assets/Profile.jpeg';
import portraitImage from '../assets/pr.jpeg';
import contentSparkVisual from '../assets/content-spark-home.png';
import developerVisual from '../assets/developer-nav-code-home.png';

const portfolioConfig = {
  personal: {
    name: 'Abhinav Dhawan',
    role: 'Full Stack Developer',
    subtitle: 'Product-minded frontend and full-stack delivery',
    availability: 'Open to freelance and product collaborations',
    tagline:
      'I turn rough ideas into clear, fast web products with strong UI direction, dependable backend foundations, and a sharper visual finish.',
    intro:
      'This version of the portfolio is intentionally less glossy and more grounded. The focus is on live work, practical stack choices, and interfaces that feel authored instead of auto-generated.',
    description:
      'I build modern web experiences with React, JavaScript, Node.js, and deployment-minded workflows. My best work sits at the intersection of product thinking, front-end polish, and shipping speed.',
    email: 'abhinavff987@gmail.com',
    phone: '+91 6392 697 302',
    location: 'India',
    cv: 'https://drive.google.com/file/d/1etm33K7SNUKIcbdpora8iWe887FdwwAQ/view?usp=sharing',
    profileImage,
    portraitImage
  },

  heroHighlights: [
    {
      value: '03',
      label: 'current product links',
      note: 'wired into the new portfolio and terminal'
    },
    {
      value: '02+',
      label: 'years building',
      note: 'shipping web interfaces and product experiments'
    },
    {
      value: 'Remote',
      label: 'working style',
      note: 'async-friendly, detail-focused, and fast on iteration'
    }
  ],

  principles: [
    {
      title: 'Designed, not decorated',
      description:
        'I prefer structure, typography, and spacing over visual noise. Motion is there to guide attention, not to overpower the content.'
    },
    {
      title: 'Built around real products',
      description:
        'This portfolio now reflects active projects and real product directions instead of placeholder work or made-up case studies.'
    },
    {
      title: 'Frontend that still ships',
      description:
        'I care about the build path as much as the pixels: responsive layouts, practical tooling, and dependable deployment decisions.'
    }
  ],

  stackGroups: [
    {
      title: 'Frontend systems',
      summary:
        'Interfaces that feel sharp on first load and stay consistent as products grow.',
      items: ['React', 'JavaScript', 'Next.js', 'TypeScript', 'Tailwind CSS', 'Responsive UI']
    },
    {
      title: 'Backend and product wiring',
      summary:
        'APIs, app logic, and integrations that support real product behavior instead of mock screens.',
      items: ['Node.js', 'Express.js', 'REST APIs', 'MongoDB', 'PostgreSQL', 'Authentication flows']
    },
    {
      title: 'Delivery and tooling',
      summary:
        'Simple release paths, deployment awareness, and a toolkit that keeps momentum high.',
      items: ['Git', 'GitHub', 'Docker', 'AWS', 'Vercel', 'Postman']
    }
  ],

  experience: [
    {
      period: '2025 - Present',
      title: 'Independent builder',
      company: 'Nav-code projects',
      summary:
        'Iterating on product ideas across AI tooling, content workflows, and personal brand surfaces.',
      wins: [
        'Shipping and refining live product landing pages',
        'Balancing design direction with practical implementation speed',
        'Turning rough concepts into launchable interfaces'
      ]
    },
    {
      period: '2023 - 2025',
      title: 'Full stack freelance work',
      company: 'Client and self-initiated builds',
      summary:
        'Building web apps end-to-end with React on the frontend and Node.js-backed services on the backend.',
      wins: [
        'Responsive frontends built for real-world usage',
        'Backend foundations for content, auth, and data-driven experiences',
        'Deployment-ready builds with cleaner handoff paths'
      ]
    }
  ],

  services: [
    {
      title: 'Landing pages with product character',
      summary:
        'I build launch pages and marketing surfaces that feel tailored to the product instead of assembled from trendy defaults.',
      bullets: ['Clear visual direction', 'Responsive build quality', 'Motion used with restraint']
    },
    {
      title: 'Frontend implementation for real products',
      summary:
        'From hero section to dashboard surface, I focus on UI systems that stay readable, scalable, and fast to navigate.',
      bullets: ['Component-led delivery', 'Accessible interactions', 'Theme-aware styling']
    },
    {
      title: 'Full-stack execution',
      summary:
        'When the product needs more than presentation, I wire up the app logic, API layer, and deployment path too.',
      bullets: ['Node.js and API work', 'Database-backed features', 'Deployment and iteration support']
    }
  ],

  projects: [
    {
      id: 'aiobot',
      index: '01',
      title: 'AioBot',
      label: 'aiobot.online',
      summary:
        'This is one of the three current product links supplied for the portfolio refresh. The domain is now represented honestly in the site and terminal instead of being replaced with older sample work.',
      detail:
        'I could not inspect the live experience because the host returned a 502 bad gateway response on March 29, 2026. Rather than invent features, the redesigned portfolio presents it as an active project with a live-status note.',
      technologies: ['AI', 'Automation', 'Product Link'],
      url: 'https://aiobot.online',
      status: 'Temporarily unavailable',
      inspectionNote: 'Host returned 502 during inspection on March 29, 2026.',
      tone: 'aiobot',
      visual: null
    },
    {
      id: 'content-spark',
      index: '02',
      title: 'Content Spark',
      label: 'content.nav-code.com',
      summary:
        'An AI content generation product positioned around fast creation, reusable templates, audience targeting, and conversion-oriented copy.',
      detail:
        'During inspection, the live page emphasized creator workflow speed, template-driven generation, and polished CTA sections for a clear SaaS landing page experience.',
      technologies: ['React', 'AI UX', 'Landing Page'],
      url: 'https://content.nav-code.com',
      status: 'Live',
      inspectionNote: 'Inspected live on March 29, 2026.',
      tone: 'content',
      visual: contentSparkVisual
    },
    {
      id: 'developer-nav-code',
      index: '03',
      title: 'Developer.Nav-Code',
      label: 'developer.nav-code.com',
      summary:
        'The earlier portfolio build with an interactive terminal, skills overview, services section, and contact flow.',
      detail:
        'I used this live version as the baseline reference for the redesign so the new portfolio could keep the good ideas while removing the AI-generated glassmorphism feel.',
      technologies: ['React', 'Portfolio', 'UI Refresh'],
      url: 'https://developer.nav-code.com',
      status: 'Live',
      inspectionNote: 'Inspected live on March 29, 2026.',
      tone: 'developer',
      visual: developerVisual
    }
  ],

  social: {
    github: 'https://github.com/IG-ABHINAV',
    linkedin: 'https://linkedin.com/in/abhinavdhawan',
    email: 'mailto:abhinavff987@gmail.com',
    whatsapp: 'https://wa.me/916392697302'
  },

  terminal: {
    promptUser: 'abhinav@studio',
    directory: '~/workspace'
  },

  site: {
    title: 'Abhinav Dhawan | Full Stack Developer',
    description:
      'Portfolio for Abhinav Dhawan featuring current products, a refreshed UI system, and an interactive project terminal.'
  }
};

export default portfolioConfig;
